<main class="container">
    <section id="column1" npSetLayout [pageLayout]="PageLayout.Layout12">
        <div id="row1" class="row">
            <div class="col col-12">
                <h1>request dashboard by type</h1>
                <by-request-type [requestType]="initialRequestType"
                    [barColor]="initialRequestType | mapWorkflowTypeToColor" [allowRequestTypeChange]="true"
                    [showDetails]="true" [numberOfMonths]="numberOfMonths"></by-request-type>
            </div>
        </div>
    </section>
</main>